<template>
  <div>
    <el-table
      :data="tableData"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="属性名称">
        <template slot-scope="scope">
          <el-input size="mini" class="form-input" v-model="scope.row.name" autocomplete="off" @change="changeInput(scope.$index,scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="value"
        label="属性值">
        <template slot-scope="scope">
          <el-input size="mini" class="form-input" v-model="scope.row.value" autocomplete="off" @change="changeInput(scope.$index,scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="50">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="delTableData(scope.$index)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <el-button size="mini" type="primary" icon="el-icon-circle-plus" circle @click="addTableData"></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BpmnExtend",
  props:{
    tableDataProps:{
      type:Array,
      default(){
        return [];
      }
    }
  },
  model:{
    prop:"tableDataProps",
    event:"success",
  },
  data() {
    return {
      tableData:[]
    }
  },
  mounted() {
    this.onInitTable()
  },
  watch: {
    tableDataProps:{
      deep:true,
      immediate:true,
      handler(n){
        this.onInitTable()
      }
    }
  },
  computed: {},
  methods: {
    onInitTable(){
      this.tableData=this.tableDataProps
    },
    addTableData(){
      this.tableData.push({name:"",value:""});
      this.$emit("success",this.tableData)
    },
    delTableData(index){
      this.tableData.splice(index,1);
      this.$emit("success",this.tableData)
    },
    changeInput(index,item){
      this.tableData[index]=item;
      this.$emit("success",this.tableData)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.form-input{
  width: 100%;
}
.footer{
  margin: 5px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/components/BpmnExtend.vue